import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const ResetPasswordPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Сброс пароля
      </Typography>
      <Box sx={{ mt: 4 }}>
        <Typography variant="body1" color="text.secondary">
          Страница сброса пароля в разработке...
        </Typography>
      </Box>
    </Container>
  );
};

export default ResetPasswordPage;